import { pipe } from "fp";

import { type, creator, reducer } from "~/Action";
import * as Driver from "~/Driver";
import { useSelector } from "~/State";

import * as Type from "./Type";

export { Type };

export type Sort = {
  readonly type: Type.Type;
  readonly direction: Direction.Direction;
};

export const initial = (): Sort => ({
  type: Type.status(),
  direction: Direction.descending(),
});

export const equals = (a: Sort) => (b: Sort): boolean =>
  a.type === b.type && a.direction === b.direction;

export const useActive = (): Sort =>
  useSelector({ equals, select: ({ drivers: { sort } }) => sort.active });

export namespace Direction {
  export type Direction = ReturnType<typeof ascending | typeof descending>;
  export const ascending = () => "ASCENDING" as const;
  export const descending = () => "DESCENDING" as const;
}

export namespace State {
  export type State = { readonly active: Sort };
  export const initial = (): State => ({
    active: {
      type: Type.status(),
      direction: Direction.descending(),
    },
  });
}

export namespace Action {
  export namespace Updated {
    export const { TYPE, create, reduce } = pipe(
      type("Drivers updated sort" as const),
      creator((sort: Pick<Driver.Sort.Sort, "type">) => ({
        sort,
      })),

      reducer(
        ({ state, action: { sort } }) =>
          (state.drivers.sort.active = updateSort(
            state.drivers.sort.active,
            sort
          ))
      )
    );
  }

  const updateSort = (previous: Sort, sort: Pick<Sort, "type">): Sort =>
    previous.direction === Direction.ascending()
      ? initial()
      : {
          ...sort,
          direction:
            previous.type === sort.type &&
            previous.direction === Driver.Sort.Direction.descending()
              ? Driver.Sort.Direction.ascending()
              : Driver.Sort.Direction.descending(),
        };
}
